var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 21.748c3.028-2.178 5-5.733 5-9.748 0-6.627-5.373-12-12-12S0 5.373 0 12a11.987 11.987 0 006.118 10.462c.566.35 1.361.713 2.31.997C9.556 23.811 10.756 24 12 24h.093c.732 0 1.436-.075 2.097-.2.684-.126 1.348-.31 1.987-.547.909-.333 1.647-.722 2.14-1.048.232-.144.46-.296.681-.456l.011.371-.01-.372zm-.007-.174l.005.175H19a1.573 1.573 0 00-.007-.175zm0 0c0-.952-.523-1.915-1.377-2.34l-3.003-1.497a1.141 1.141 0 01-.633-1.02v-1.174c.084-.096.18-.22.284-.364a6.87 6.87 0 00.933-1.875.94.94 0 00.669-.894v-1.253a.933.933 0 00-.315-.694V8.65s.373-2.819-3.458-2.819c-3.831 0-3.458 2.82-3.458 2.82v1.81a.933.933 0 00-.314.695v1.253c0 .33.174.62.435.789a6.205 6.205 0 001.137 2.344v1.144c0 .418-.23.802-.597 1.002L6.49 19.214a2.51 2.51 0 00-1.314 2.205v.075c0 .24.343.598.941.968.727.41 1.5.745 2.31.997 1.056.317 2.304.538 3.64.54a12.057 12.057 0 002.122-.198c.721-.136 1.39-.33 1.987-.548a11.957 11.957 0 002.14-1.048c.433-.287.676-.525.676-.631z",
    fill: "var(--color-secondary-light)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user-circle.b57f9d52c020efe1e0e69440df95332f.svg";
export { ForwardRef as ReactComponent };